import { Select, SelectOptions } from '@trackman/web-shared-components';

import { SelectedItemDto } from 'types/CodegenReportTypes';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';

type Props = {
  allSessions: SelectOptions[] | undefined;
  excludedSessions: SelectOptions[] | undefined;
  setExcludedSessions: (newValue: SelectedItemDto[]) => void;
  disabled: boolean;
};

const SessionFilter = ({ allSessions = [], excludedSessions = [], setExcludedSessions, disabled }: Props) => {
  const selectedOptions = allSessions
    .filter((session) => !excludedSessions.some((excluded) => excluded.value === session.value))
    .map((session) => session.value);

  const { t } = useTranslation();

  const selectRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selectRef.current) {
      const selectedCount = selectedOptions.length;
      const totalOptions = allSessions.length;

      let displayText = '';

      if (selectedCount === totalOptions && totalOptions > 0) {
        displayText = t('All selected');
      } else if (selectedCount > 0) {
        displayText = `${selectedCount} ${t('selected')}`;
      }

      const valueContainer = selectRef.current.querySelector('.MuiSelect-select');
      if (valueContainer && displayText) {
        (valueContainer as HTMLElement).innerText = displayText;
      }
    }
  }, [selectedOptions, allSessions]);

  return (
    <Select
      ref={selectRef}
      label={t('Session')}
      onChange={(e) => {
        const newSelected = e.target.value as string[];
        const newExcludedSessions = allSessions
          .filter((session) => !newSelected.includes(String(session.value)))
          .map((session) => ({ name: String(session.label), id: String(session.value) }));
        setExcludedSessions(newExcludedSessions);
      }}
      selectOptions={allSessions}
      value={selectedOptions}
      disabled={disabled}
      multiple
    />
  );
};

export default SessionFilter;
